import React from 'react';
import {Fragment} from 'react';
import {Dialog, Transition} from '@headlessui/react';
import {XMarkIcon} from '@heroicons/react/24/outline';
import {Heading} from '../elements';
export function FilterDrawer({
  mobileFiltersOpen,
  setMobileFiltersOpen,
  children,
}) {
  return (
    // Mobile View Filter Drawer
    <Transition.Root show={mobileFiltersOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-40 mb-10 lg:hidden"
        onClose={setMobileFiltersOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-opacity-25"/>
        </Transition.Child>

        <div className="fixed inset-0 bg-gray-400/50 w-screen h-screen z-40 flex">
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-full"
          >
            <Dialog.Panel className="relative ml-auto flex h-full w-full max-w-xs flex-col bg-white overflow-y-auto py-4 pb-12 shadow-xl">
              <div className="flex items-center justify-between px-4 py-2">
                <Heading as="h3" size='Lead'>All Filters</Heading>
                <button
                  type="button"
                  className="-mr-2 flex h-10 w-10 items-center justify-center rounded-md p-2"
                  onClick={() => setMobileFiltersOpen(false)}
                >
                  <Heading className="sr-only">Close menu</Heading>
                  <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                </button>
              </div>
              {children}
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
